import { call, put, takeEvery } from 'redux-saga/effects';
import {
    FETCH_CLAIMS_TRIPS_REQUEST,
    FETCH_CLAIMS_TRIPS_SUCCESS,
    FETCH_CLAIMS_TRIPS_FAILURE,
    FETCH_CLAIMS_ACTIVITIES_REQUEST,
    FETCH_CLAIMS_ACTIVITIES_SUCCESS,
    FETCH_CLAIMS_ACTIVITIES_FAILURE,
} from '../actions/dataActions';
import {
    FETCH_CLAIMS_REQUEST,
    FETCH_CLAIMS_SUCCESS,
    FETCH_CLAIMS_FAILURE,
    FETCH_CHECK_CLAIMS_REQUEST,
    FETCH_CHECK_CLAIMS_SUCCESS,
    FETCH_CHECK_CLAIMS_FAILURE,
} from '../actions/claimsActions';
import { getClaimsTrips, getClaimsActivities, getClaims, getCheckClaims } from '../../services/api';
import { handleApiError } from '../../utils/errorHandler';

/**
 * Saga pour récupérer les sinistres de séjours (trips)
 */
function* fetchClaimsTripsSaga() {
    try {
        const data = yield call(getClaimsTrips);
        yield put({ type: FETCH_CLAIMS_TRIPS_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement des sinistres de séjours');
        yield put({ type: FETCH_CLAIMS_TRIPS_FAILURE, payload: errorMessage });
    }
}

/**
 * Saga pour récupérer les sinistres d'activités
 */
function* fetchClaimsActivitiesSaga() {
    try {
        const data = yield call(getClaimsActivities);
        yield put({ type: FETCH_CLAIMS_ACTIVITIES_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement des sinistres d\'activités');
        yield put({ type: FETCH_CLAIMS_ACTIVITIES_FAILURE, payload: errorMessage });
    }
}

/**
 * Saga pour récupérer les sinistres d'activités avec pagination et filtres
 */
function* fetchClaimsSaga(action) {
    try {
        const params = action.payload || {};
        const data = yield call(getClaims, params);
        yield put({ type: FETCH_CLAIMS_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement des sinistres d\'activités');
        yield put({ type: FETCH_CLAIMS_FAILURE, payload: errorMessage });
    }
}

/**
 * Saga pour récupérer les check claims avec pagination et filtres
 */
function* fetchCheckClaimsSaga(action) {
    try {
        const params = action.payload || {};
        const data = yield call(getCheckClaims, params);
        yield put({ type: FETCH_CHECK_CLAIMS_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement des check claims');
        yield put({ type: FETCH_CHECK_CLAIMS_FAILURE, payload: errorMessage });
    }
}

/**
 * Watcher pour les actions de sinistres
 */
export function* watchClaimsRequests() {
    yield takeEvery(FETCH_CLAIMS_TRIPS_REQUEST, fetchClaimsTripsSaga);
    yield takeEvery(FETCH_CLAIMS_ACTIVITIES_REQUEST, fetchClaimsActivitiesSaga);
    yield takeEvery(FETCH_CLAIMS_REQUEST, fetchClaimsSaga);
    yield takeEvery(FETCH_CHECK_CLAIMS_REQUEST, fetchCheckClaimsSaga);
}




